import React from "react";
import LinearProgressBar from "~/components/progressBar/LinearProgressBar";


const CheckInProgress = ({rewards, progress})=> {

  return (
    <div className="check-in-progress-container">
      <div className="overflow-hidden">
        <div className="pull-left">Days</div>
        <div className="pull-right">Points</div>
      </div>
      { rewards.length
        ? rewards.map((el, index)=>
          <LinearProgressBar key={index} start={index ? rewards[index-1].daysThreshold : 0} end={el.daysThreshold} reward={el} progress={progress} />
        ) : null
      }
    </div>
  )
}

export default CheckInProgress;
